import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-all-chief-patrons',
  templateUrl: './all-chief-patrons.component.html',
  styleUrls: ['./all-chief-patrons.component.scss']
})
export class AllChiefPatronsComponent implements OnInit, OnDestroy {
  ChiefPatrons: any;
  fetchinData = true;
  private ngUnsubscribe = new Subject();

  constructor(private appService: AppService, private _changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.FetchChiefPatrons();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  FetchChiefPatrons() {
    this.fetchinData = true;
    forkJoin([
      this.appService.getContents(),
    ]).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
      const allData = response[0].data || [];
      this.ChiefPatrons = allData.filter((x: any) => x.ContentCategoryName === 'All Chief Patrons');
      this.fetchinData = false;
      this._changeDetectorRef.markForCheck();
    });
  }
}
